import { IClientsCategoryRepository } from '@/repository/clients/ClientsCategoryRepository.types';

import { IClientsCategories, IClientsCategoriesListItem, ClientsCategoriesResponseType } from '@/entity/clients/clientsCategories.types';

import Api from '@/repository/api';
import ClientsCategories from '@/entity/clients/clientsCategories';
import { ClientsCategoriesRequestType } from '@/form/Settings/categories/clients.types';

import qs from 'qs';
import { PaginationRequestType } from '@/entity/common/pagination.types';
import { ResponseDataType } from '@/form/form.types';


export class ClientsCategoryRepository implements IClientsCategoryRepository {
    async fetchAll(data?: FormData): Promise<IClientsCategories> {
        console.log('++++++++++++++++++++1676482010++++++++++++++++++++++++');console.log('data : ' + (typeof data));console.log(data);console.log('--------------------1676482010------------------------');

        const response = await Api.get(`/clients/category/get`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString();
            }
        });
        
        const responseData = response.data as ClientsCategoriesResponseType;
        return new ClientsCategories(responseData);
    }
    async fetchData(data: PaginationRequestType): Promise<IClientsCategoriesListItem> {
        console.log('Client query - ')
        const response = await Api.get(`/clients/category/get`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                console.log('Client params - '+ params)
                return qs.stringify(params, { arrayFormat: 'repeat' });
            }
        });
        //const responseData = response.data as ClientsResponseType;
        const responseData = response.data as ClientsCategoriesResponseType;
        //return new Clients(responseData)

        return new ClientsCategories(responseData).data[0];
    }
    async create(data: ClientsCategoriesRequestType): Promise<boolean> {
        const response = await Api.post(`/clients/category/create`, data);
        const responseData = response.data;
        return responseData;
    }
    async update(data: ClientsCategoriesRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/clients/category/update`, data);
        const responseData = response.data;
        return responseData;
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/clients/category/delete`, data);
        const responseData = response.data;
        return responseData;
    }
}
